export const ROLE_DETAILS_PERMISSIONS_TITLE = "Permissions:roleId";

export const linkToRolePermissionsPage = (roleId = ":roleId") =>
  `/app/settings/roles-and-permissions/roles/${roleId}/detail?tab=permissions`;

export const ROLE_DETAILS_PERMISSIONS_BREADCRUMB = {
  title: ROLE_DETAILS_PERMISSIONS_TITLE,
  path: linkToRolePermissionsPage,
};
